import React, { useState } from 'react';
import { Rocket, Clock, Globe, Settings, Check, Wifi, Cloud, Shield } from 'lucide-react';

import Footer from '../../components/footer/index';
import ProdukStarlink from '../../components/navbar/internet/internet-starlink/starlink';
import Section from '../../components/navbar/internet/internet-starlink/section';
import Elements from '../../components/navbar/internet/internet-starlink/element';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';

const StarlinkPage = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [activeTab, setActiveTab] = useState('semua');
  const [showComparison, setShowComparison] = useState(false);
  const { isDarkMode } = useDarkMode();

   const packages = [
    {
      id: 'home-basic',
      category: 'home',
      speed: '100 Mbps',
      name: 'NetSpeed Home Basic',
      description: 'Perfect untuk streaming HD dan browsing keluarga sehari-hari',
      price: 'Rp 299.000',
      originalPrice: 'Rp 399.000',
      discount: '25%',
      badge: 'PROMO',
      badgeColor: 'bg-red-500',
      popular: false,
      features: [
        { name: '10 devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Support 24/7', icon: '/image/icon/support.png' },
        { name: 'Free installation', icon: '/image/icon/free_installation.png' },
        { name: 'Router included', icon: '/image/icon/router.png' },
        { name: 'Speed up to 100 Mbps', icon: '/image/icon/speed.png' }
      ],
      ideal: ['Browsing internet', 'Streaming HD', 'Video call', 'Social media'],
      devices: '10 devices',
      installation: 'GRATIS',
      support: '24/7',
      sla: '-'
    },
    {
      id: 'home-pro',
      category: 'home',
      speed: '500 Mbps',
      name: 'NetSpeed Home Pro',
      description: 'Ideal untuk gaming dan streaming 4K multiple device',
      price: 'Rp 499.000',
      originalPrice: 'Rp 649.000',
      discount: '23%',
      badge: 'POPULER',
      badgeColor: 'bg-blue-900',
      popular: true,
      features: [
        { name: '20 devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Priority support', icon: '/image/icon/priority.png' },
        { name: 'Free router premium', icon: '/image/icon/router.png' },
        { name: 'Gaming optimization', icon: '/image/icon/gaming.png' },
        { name: 'Speed up to 500 Mbps', icon: '/image/icon/speed.png' }
      ],
      ideal: ['Gaming online', 'Streaming 4K', 'Work from home', 'Multiple users'],
      devices: '20 devices',
      installation: 'GRATIS',
      support: 'Priority 24/7',
      sla: '-'
    },
    {
      id: 'gaming-ultra',
      category: 'gaming',
      speed: '1 Gbps',
      name: 'NetSpeed Gaming Ultra',
      description: 'Zero lag gaming dengan ping <10ms dan kecepatan ultra',
      price: 'Rp 799.000',
      originalPrice: 'Rp 999.000',
      discount: '20%',
      badge: 'GAMING',
      badgeColor: 'bg-green-600',
      popular: false,
      features: [
        { name: '30+ devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Gaming optimization', icon: '/image/icon/gaming.png' },
        { name: 'Static IP', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Low latency <10ms', icon: '/image/icon/speed.png' },
        { name: 'Speed up to 1 Gbps', icon: '/image/icon/speed.png' }
      ],
      ideal: ['Pro gaming', 'Live streaming', 'Content creation', 'Heavy download'],
      devices: '30+ devices',
      installation: 'GRATIS',
      support: 'Gaming Support 24/7',
      sla: '-'
    },
    {
      id: 'business-enterprise',
      category: 'business',
      speed: 'Dedicated',
      name: 'Business Enterprise',
      description: 'Bandwidth dedicated dengan SLA 99.9% untuk kebutuhan bisnis',
      price: 'Custom Pricing',
      originalPrice: null,
      discount: null,
      badge: 'BISNIS',
      badgeColor: 'bg-blue-600',
      popular: false,
      features: [
        { name: 'Custom devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Dedicated support', icon: '/image/icon/priority.png' },
        { name: 'SLA 99.9%', icon: '/image/icon/SLA.png' },
        { name: 'Static IP', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Dedicated bandwidth', icon: '/image/icon/Dedicated.png' }
      ],
      ideal: ['Office operations', 'E-commerce', 'Data center', 'Enterprise apps'],
      devices: 'Unlimited',
      installation: 'Konsultasi',
      support: 'Dedicated 24/7',
      sla: '99.9%'
    }
  ];

  return (
    <div
      className={`min-h-screen transition-colors duration-500 ${
        isDarkMode ? 'bg-slate-900 text-white' : 'bg-white text-gray-900'
      }`}
    >
      <Section />

      {/* Header Section */}
      <div className="relative overflow-hidden">
        <div
          className={`absolute inset-0 ${
            isDarkMode
              ? 'bg-gradient-to-br from-blue-900/30 to-slate-900'
              : 'bg-gradient-to-br from-blue-100/30 to-slate-100'
          }`}
        ></div>

        {/* Decorative Elements */}
        <Elements />
        <div
          className={`absolute top-20 right-10 w-32 h-32 rounded-full blur-xl ${
            isDarkMode ? 'bg-blue-500/10' : 'bg-blue-300/20'
          }`}
        ></div>
        <div
          className={`absolute bottom-20 left-10 w-40 h-40 rounded-full blur-xl ${
            isDarkMode ? 'bg-cyan-500/10' : 'bg-cyan-300/20'
          }`}
        ></div>
      </div>

      <ProdukStarlink />

      {/* Features Section */}
      <div
        className={`py-16 ${
          isDarkMode ? 'bg-slate-800/50' : 'bg-gray-100/50'
        }`}
      ></div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-[#1E9B4C] to-green-700 py-24">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Siap Terhubung dengan Masa Depan?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Bergabunglah dengan jutaan pengguna Starlink di seluruh dunia
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-[#1E9B4C] hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors">
              Mulai Sekarang
            </button>
            <button className="border border-white text-white hover:bg-white/10 px-8 py-3 rounded-lg font-semibold transition-colors">
              Pelajari Lebih Lanjut
            </button>
          </div>
        </div>
      </div>

      {/* Modal Detail Package */}
      {selectedPackage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div
            className={`rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto transition-colors ${
              isDarkMode ? 'bg-gray-800' : 'bg-white'
            }`}
          >
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <h2
                    className={`text-3xl font-bold mb-2 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    {selectedPackage.name}
                  </h2>
                  <div className="text-blue-400 text-xl font-semibold">
                    {selectedPackage.speed}
                  </div>
                </div>
                <button
                  onClick={() => setSelectedPackage(null)}
                  className={`text-3xl ${
                    isDarkMode
                      ? 'text-gray-400 hover:text-white'
                      : 'text-gray-600 hover:text-black'
                  }`}
                >
                  ×
                </button>
              </div>

              <div className="space-y-8">
                {/* Price Section */}
                <div
                  className={`rounded-xl p-6 mb-6 ${
                    isDarkMode ? 'bg-gray-700' : 'bg-gray-100'
                  }`}
                >
                  <div className="flex items-baseline gap-2 mb-4">
                    <span
                      className={`text-4xl font-bold ${
                        isDarkMode ? 'text-white' : 'text-gray-900'
                      }`}
                    >
                      {selectedPackage.price}
                    </span>
                    {selectedPackage.originalPrice && (
                      <>
                        <span className="text-xl text-gray-400 line-through">
                          {selectedPackage.originalPrice}
                        </span>
                        <span className="bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                          -{selectedPackage.discount}
                        </span>
                      </>
                    )}
                  </div>
                  {selectedPackage.price !== 'Custom Pricing' && (
                    <div
                      className={`${
                        isDarkMode ? 'text-gray-400' : 'text-gray-600'
                      }`}
                    >
                      per bulan
                    </div>
                  )}
                </div>

                {/* All Features Section */}
                <div>
                  <h3
                    className={`text-2xl font-semibold mb-4 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    Semua Fitur & Keunggulan
                  </h3>
                  <div className="space-y-4">
                    {selectedPackage.features.map((feature, i) => (
                      <div key={i} className="flex items-center gap-4">
                        {feature.icon && (
                          <img
                            src={feature.icon}
                            alt={feature.name}
                            className="w-12 h-12 object-contain"
                          />
                        )}
                        <span
                          className={`text-lg ${
                            isDarkMode ? 'text-gray-300' : 'text-gray-700'
                          }`}
                        >
                          {feature.name}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Ideal Uses Section */}
                <div>
                  <h3
                    className={`text-2xl font-semibold mb-4 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    Cocok Untuk
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {selectedPackage.ideal.map((use, i) => (
                      <div
                        key={i}
                        className={`px-4 py-2 rounded-lg text-sm text-center ${
                          isDarkMode
                            ? 'bg-gray-700 text-gray-300'
                            : 'bg-gray-200 text-gray-700'
                        }`}
                      >
                        {use}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-6 mt-8">
                  <button className="flex-1 bg-blue-900 hover:bg-blue-800 text-white py-4 rounded-xl font-semibold transition-colors">
                    {selectedPackage.price.includes('Custom')
                      ? 'Konsultasi'
                      : 'Pesan Sekarang'}
                  </button>
                  <button
                    onClick={() => setSelectedPackage(null)}
                    className={`flex-1 border py-4 rounded-xl font-semibold transition-colors ${
                      isDarkMode
                        ? 'border-gray-600 text-gray-300 hover:text-white hover:border-gray-500'
                        : 'border-gray-400 text-gray-700 hover:text-black hover:border-gray-600'
                    }`}
                  >
                    Tutup
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default StarlinkPage;